import { FlexHorizontalAlign } from "../../../../../base/styles";
import clsx from "clsx";

export const SelectHorizontalAlign = ({ title, value, className, onChange }:{
    title: string,
    value?: FlexHorizontalAlign,
    className?: string,
    onChange: (value?: FlexHorizontalAlign) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as FlexHorizontalAlign;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={FlexHorizontalAlign.Start}>Start</option>
                <option value={FlexHorizontalAlign.End}>End</option>
                <option value={FlexHorizontalAlign.Center}>Center</option>
                <option value={FlexHorizontalAlign.Between}>Between</option>
                <option value={FlexHorizontalAlign.Around}>Around</option>
                <option value={FlexHorizontalAlign.Evenly}>Evenly</option>
            </select>
        </div>
    )
}